import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  trustedShopsAriaLabel: {
    id: 'Seals.trustedShops.ariaLabel',
    defaultMessage: 'Weitere Informationen unter Trusted Shops',
  },
  ehiAriaLabel: {
    id: 'Seals.ehi.ariaLabel',
    defaultMessage: 'Weitere Informationen zum EHI Siegel',
  },
  staatswappenAriaLabel: {
    id: 'Seals.staatswappen.ariaLabel',
    defaultMessage: 'Weitere Informationen zu staatlichen Auszeichnungen',
  },
  handelsverbandAriaLabel: {
    id: 'Seals.handelsverband.ariaLabel',
    defaultMessage: 'Weitere Informationen zum  Handelsverband Austria',
  },
  oeonlineAriaLabel: {
    id: 'Seals.oeonline.ariaLabel',
    defaultMessage: 'Weitere Informationen zu unseren Auszeichnungen',
  },
});
